import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset, change } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';

import { renderCheckBox, isValidNameWithSpace, renderDateField, renderAutoCompleteMultipleSelection, renderAutoCompleteSingleSelect, renderTextField } from '../../../../components/reduxFields';
import { getDataAnalytics } from './actions/dataAnalyticsActions';
import { base64Decode } from '../../../../actions/utilAction';
import { getTargetsAndProgramsData } from '../../../scheduling/components/SessionNotes_EBS/actions/soapActions';
import AnalyticsDataComponent from './analyticsDataComponent';
import validate from './validate';

class DataAnalytics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            patientId: props.match.params.id ? base64Decode(props.match.params.id) : 0,
            masterPatientPrograms: '',
            masterPatientGoals: '',
            showGraph: '',
            xAxisName: null,
            yAxisName: null,
            disableYaxislabel: true,
            disableXaxislabel: true,
            selectedProgram: '',
        }
    }

    componentWillMount = () => {
        this.props.getTargetsAndProgramsData(this.state.patientId);
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            masterPatientPrograms: nextProps.masterPatientPrograms,
        });
    }


    onDateChange = (input, value) => {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value });
    }

    dataAnalyticsSubmit = (event) => {
        let patientId = this.state.patientId;
        let targetId = event.targetId;
        if (patientId && targetId) {
            this.setState({
                showGraph: true,
                xAxisName: event.XAxisName,
                yAxisName: event.YAxisName,
                disableYaxislabel: event.disableYaxislabel === undefined ? this.state.disableYaxislabel : !event.disableYaxislabel,
                disableXaxislabel: event.disableXaxislabel === undefined ? this.state.disableXaxislabel : !event.disableXaxislabel
            });
        }
        let FromDate = event.FromDate ? moment(event.FromDate).format('YYYY-MM-DD') : moment(this.state.FromDate).format('YYYY-MM-DD');
        let ToDate = event.ToDate ? moment(event.ToDate).format('YYYY-MM-DD') : moment(this.state.ToDate).format('YYYY-MM-DD');
        // this.setState({
        //     FromDate: FromDate,
        //     ToDate: ToDate
        // })
        this.props.getDataAnalytics(patientId, targetId, FromDate, ToDate);
    }

    handleReset = () => {
        this.props.dispatch(reset('DataAnalyticsForm'));
        this.setState({
            FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
            ToDate: new Date(),
            showGraph: ''
        })
    }

    programChangeHandler = (input, selected) => {
        input.onChange(selected.value)
        let filteredMasterPatientGoals = [];
        filteredMasterPatientGoals = this.props.masterPatientGoals.filter(obj => {
            return obj.programId === selected.value
        });
        this.props.dispatch(change('DataAnalyticsForm', 'targetId', null));
        this.setState({
            masterPatientGoals: filteredMasterPatientGoals,
            showGraph: '',
            selectedProgram: selected.label,
        })
    }

    handleNewRequestMultiSelect = (input, selectedValues) => {
        input.onChange(selectedValues);
        this.setState({
            showGraph: ''
        })

    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <h2 className="page_title">Skill Acquisition Graphs</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <form className="readmin-form custom_form" onSubmit={handleSubmit(this.dataAnalyticsSubmit)}>
                            <div className='row'>
                                <div className="col-sm-6 mt-10 require">
                                    <Field
                                        name='programId'
                                        label="Program Name"
                                        options={this.state.masterPatientPrograms}
                                        handleNewRequest={(input, selected) => this.programChangeHandler(input, selected)}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10 require">
                                    <Field
                                        name='targetId'
                                        label="Target Name"
                                        options={this.state.masterPatientGoals}
                                        handleNewRequest={this.handleNewRequestMultiSelect}
                                        component={renderAutoCompleteMultipleSelection}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="FromDate"
                                        placeholder="From Date"
                                        locale="en-US"
                                        selected={this.state.FromDate}
                                        onDateChange={this.onDateChange}
                                        openToYearSelection={true}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="ToDate"
                                        placeholder="To Date"
                                        locale="en-US"
                                        minDate={this.state.FromDate}
                                        selected={this.state.ToDate}
                                        openToYearSelection={true}
                                        onDateChange={this.onDateChange}
                                        component={renderDateField} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="XAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="X-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field
                                        name="YAxisName"
                                        type="text"
                                        maxLength="250"
                                        label="Y-Axis Name"
                                        normalize={isValidNameWithSpace}
                                        component={renderTextField}
                                    />
                                </div>
                                 <div className="col-sm-6 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="disableXaxislabel" 
                                        label="Disable X Axis Label"
                                        component={renderCheckBox} />
                                </div>
                                <div className="col-sm-6 mt-10">
                                    <Field 
                                        className="mt20 mb0" 
                                        name="disableYaxislabel" 
                                        label="Disable Y Axis Label"
                                        component={renderCheckBox} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 btn_rt reset-btn claims_filter mt-20">
                                <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate Graph</RaisedButton>
                                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                            </div>
                        </form>
                    </div>
                    {this.state.showGraph !== '' && <div className='row'>
                        {
                            this.props.dataAnalytics.loading === true
                                ?
                                <div className="col-sm-12 text-center no-record" >Loading...</div>
                                :
                                <AnalyticsDataComponent 
                                FromDate={this.state.FromDate}
                                ToDate={this.state.ToDate} 
                                xAxisName={this.state.yAxisName}
                                yAxisName={this.state.xAxisName}
                                disableYaxislabel={this.state.disableYaxislabel}
                                disableXaxislabel={this.state.disableXaxislabel}
                                selectedProgram={this.state.selectedProgram}
                                />
                        }
                    </div>}
                </div>
            </div>
        )
    }
}

DataAnalytics = reduxForm({
    form: 'DataAnalyticsForm',
    validate,
    enableReinitialize: true,
})(DataAnalytics);

function mapStateToProps(state) {
    let masterPatientGoals = [];
    let masterPatientPrograms = [];

    if (state.soap.targetsAndProgramsData) {
        masterPatientGoals = state.soap.targetsAndProgramsData.data.Targets || [];
        masterPatientPrograms = state.soap.targetsAndProgramsData.data.Programs || [];
    }
    return {
        loading: state.patient.loading || state.patient.loadingMasterData,
        masterPatientGoals: masterPatientGoals,
        masterPatientPrograms: masterPatientPrograms,
        dataAnalytics: state.dataAnalytics
    };
}

export default connect(mapStateToProps, { getTargetsAndProgramsData, getDataAnalytics })(DataAnalytics);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataAnalytics/index.js